import { useCallback } from 'react'
import { useAppDispatch } from '@/state'

import {
  BalanceReportData,
  BalanceReportFilters,
  BalanceReportLibraryColumnProps,
  GetBalanceReportPayload,
} from '@/state/balance-report/models'
import { BalanceReportActions } from '@/state/balance-report/slices/index.slices'
import { getBalanceReportThunk } from '@/state/balance-report/thunks/get-balance-report.thunk'

import { TableHeadCellPropsType } from '@/state/ui/global/models'
import { exportXlsxFile } from '@/utils'

const useBalanceReportActions = () => {
  const dispatch = useAppDispatch()

  const getBalanceReport = async (
    filters: GetBalanceReportPayload,
    headCells?: TableHeadCellPropsType<BalanceReportLibraryColumnProps>[],
    fileName?: string,
    getFormattedRow?: (
      row: BalanceReportData,
    ) => BalanceReportLibraryColumnProps,
  ) => {
    const resultAction = await dispatch(getBalanceReportThunk({ ...filters }))

    if (
      getFormattedRow &&
      headCells &&
      getBalanceReportThunk.fulfilled.match(resultAction)
    ) {
      exportXlsxFile(
        headCells,
        resultAction.payload.docs.map((item) => getFormattedRow(item)),
        fileName,
      )
    }
  }

  const setBalanceReportFilters = useCallback(
    (filters: BalanceReportFilters) =>
      dispatch(BalanceReportActions.setBalanceReportFiltersAction(filters)),
    [dispatch],
  )

  const resetBalanceReport = useCallback(
    () => dispatch(BalanceReportActions.resetBalanceReportAction()),
    [dispatch],
  )

  return {
    getBalanceReport,
    setBalanceReportFilters,
    resetBalanceReport,
  }
}

export default useBalanceReportActions
